import { TwoColumnsGrid, TwoColumnsGridData } from "../TwoColumnsGrid";
import { Card, CardMedia } from "@material-ui/core";
import * as React from "react";

export interface OpportunityDataComponentProps {
    opportunity: any;
    rutaMapa: () => string;
}

// const fd = (date: number | null | undefined, def: string) => {
//     if (!date) {
//         return def;
//     }
//     return new Date(date).toLocaleString();
// }

export default (props: OpportunityDataComponentProps) => {
    let ruta;
    const colunms: TwoColumnsGridData[] = [];
    const { opportunity, rutaMapa }= props;
    if (opportunity.client) {
        colunms.push(
            { type: 'title', label: 'Cliente' },
            { type: 'divider' },
            { label: 'Nombre', value: opportunity.client.user.name },
            { label: 'Email', value: opportunity.client.user.email },
            { label: 'Telefono', value: opportunity.client.phone },
            { label: 'Documento', value: opportunity.client.document }
        );
    }
    
    colunms.push(
        { type: 'title', label: 'Visita #' + opportunity.id },
        { type: 'divider' },
        { label: 'Estado', value: opportunity.visitDate && opportunity.visitDate !== '' && opportunity.visited ? 'Visitado' : !opportunity.visitDate && opportunity.visited === false ? 'Cancelado' : 'Pendiente' },
        { label: 'Observación', value: opportunity.obs ? opportunity.obs : 'Sin observación' },
        { label: 'Razón de visita', value: opportunity.visitReason ? opportunity.visitReason.description : '' },
        
    );

    if (opportunity.driver) {
        colunms.push(
            { type: 'title', label: 'Visitador' },
            { type: 'divider' },
            { label: 'Nombre', value: opportunity.driver.user.name }
        );
    }

    colunms.push(
        { type: 'title', label: 'Fechas' },
        { type: 'divider' },
        { label: 'Fecha Programada', value: opportunity.visitDateTime},
        { label: 'Fecha Visitada', value: opportunity.visitDate },
    )

    if (rutaMapa && rutaMapa() !== "") {
        colunms.push(
            { type: 'title', label: 'Ruta' },
            { type: 'divider' }
        );
        ruta= rutaMapa();
    };

    return (
        <div>
            <TwoColumnsGrid data={colunms} />
            <Card>
                <CardMedia 
                    image={ruta} 
                    title="Imagen de la ruta" 
                    className="cardMedia" 
                    style={{
                        width: 400,
                        height: 400,
                        minHeight: 400,
                        margin: 'auto',
                    }}
                />
            </Card>
        </div>);
}


// WEBPACK FOOTER //
// ./src/components/visits/opportunityDataComponent.tsx